import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", () => {

  if (document.querySelector('.glide-event-banners')) {

    let glideEventBanners = new Glide('.glide-event-banners', {
      type: 'carousel',
      perView: 1.15,
      peek: {
        before: 100,
        after: 100
      },
      focusAt: 'center',
      breakpoints: {
        600: {
          perView: 1,
          peek: 0,
        },
      },
    });
    glideEventBanners.mount();

  }

});


